import { Link } from "react-router-dom";
import ResponsiveButton from "../../components/ResponsiveButton/ResponsiveButton";

// import TextToSpeech from '../../TextToSpeech/textToSpeech';

// Images
import ukkimage from "../../assets/ukk.jpg";

const text =
"Usein kysytyt kysymykset. Tervetuloa usein kysyttyjen kysymysten-osioon! Tässä osiossa vastaamme yleisimpiin kysymyksiin, joita asiakkaamme ovat tiedustelleet meiltä. Toivottavasti tämä osio auttaa sinua löytämään vastauksia kysymyksiisi. Mikäli ette löydä vastaustasi, ota rohkeasti yhteyttä! Kysy lomakkeella! paina alla olevaa nappulaa ja kysy lomakkeen kautta! ";

const Header = () => {
  return (
    <div className="relative z-10 max-w-5xl mx-auto p-4 bg-primary dark:bg-violet bg-opacity-75 dark:bg-opacity-75 pt-24">
      {/* Käytetään grid-asettelua leveämmillä näytöillä */}
      <div className="grid grid-cols-1 md:grid-cols-2 place-items-center">
        {/* Kuvan osio */}
        <div data-aos="fade-in" className="order-1 md:order-1 sm:order-1 flex justify-center">
          <img 
            src={ukkimage} 
            title="Kaukokaapeli" 
            alt="Kaukokaapeli kaapeli, joka symboloi yhteydenpitoa" 
            className="xxxsm:scale-80 xxsm:scale-85 xsm:scale-90 sm:scale-95 md:scale-70 lg:scale-55 xl:scale-60 2xl:scale-100 rotate-35 relative z-20 max-h-[500px] drop-shadow-[10px_10px_8px_rgba(0,0,0,0.80)]"
          />
        </div>

        {/* Tekstin osio */}
        <div className="p-5 rounded-3xl max-w-2xl order-2 ml-5">
          {/* Otsikko */}
          <div className="flex flex-row items-center">
            <h1 
              className="font-customFont2 dark:text-shadow-lg text-left text-darkest dark:text-primary text-5xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-[1.2]" 
              aria-label={text}
            >
              Usein kysytyt kysymykset
            </h1>
          </div>

          {/* Leipäteksti */}
          <p 
            className="font-customFont1 dark:text-shadow-lg text-left text-darkest dark:text-primary xxxsm:text-lg text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-light"
            aria-live="polite"
          >
            Tervetuloa usein kysyttyjen kysymysten (FAQ) osioon! Tässä osiossa vastaamme yleisimpiin kysymyksiin, joita asiakkaamme ovat tiedustelleet meiltä.
            <br /><br />
            Toivottavasti tämä FAQ-osio auttaa sinua löytämään vastauksia kysymyksiisi. Mikäli ette löydä vastausta kysymykseenne, ota rohkeasti yhteyttä!
          </p>

         {/* Yhteystieto-nappula */}
          <div className="pt-4 flex justify-start">
          <Link 
  to="/tee-varaus" 
  onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "auto" })}
>
  <ResponsiveButton variant="askwithform" aria-label="Yhteystiedot">
    Kysy lomakkeella
  </ResponsiveButton>
</Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
